// extracted by mini-css-extract-plugin
export default {"table-container":"FilesTable_table-container__1y2DO"};